import React from 'react';
import { Box } from '@chakra-ui/react';

export const TypeformEmbedScript = ({ formCode }) => {
  return (
    <>
      <Box
        data-tf-live={formCode}
        height="100vh"
        sx={{
          div: {
            height: `100vh`
          }
        }}
      />
      <script src="//embed.typeform.com/next/embed.js" />
    </>
  );
};

export default TypeformEmbedScript;
